import * as React from 'react';

const CancelCircle24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9.53 7.996a.75.75 0 1 0-1.06 1.06l2.47 2.47-2.47 2.47a.75.75 0 0 0 1.06 1.06L12 12.588l2.47 2.47a.75.75 0 1 0 1.06-1.061l-2.47-2.47 2.47-2.47a.75.75 0 0 0-1.06-1.06L12 10.466z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 .526c-6.076 0-11 4.926-11 11 0 6.076 4.924 11 11 11 6.074 0 11-4.924 11-11 0-6.074-4.926-11-11-11m-9.5 11a9.5 9.5 0 1 1 9.5 9.5 9.5 9.5 0 0 1-9.5-9.5"
  }
));
CancelCircle24.Size = 24;
CancelCircle24.Title = "CancelCircle";

export { CancelCircle24 as default };
